





























































import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'

export default defineClassComponent<{
  headerParallaxRate: number
  handleBackClick: Function
}>(
  {
    props: ['headerParallaxRate', 'handleBackClick'],
  },
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()
    },
)
